<template>
  <div class="deliveryGuide ql-container ql-snow">
    <!--# 배송정보 -->
      <a class="accordionBtn" @click="toggleAccordion" :class="open?'open':''">
        <span class="accordionTitle">배송정보</span><i class="icon iconDown2" :class="open?'iconUp2':'iconDown2'"></i>
      </a>
      <transition name="accordion">
        <div class="accordionData" :class="open?'open':''" >
           <div class="ql-editor" v-html="deliveryDesc" />
        </div>
        <!-- <div class="accordionData" :class="open?'open':''">
          <p class="info"><span>배송사</span>우체국택배</p>
          <p class="info"><span>배송비</span>무료</p>

          <ul class="descList">
            <li>'발송완료’ 기준 영업일 3~7일 사이에 받아 보실 수 있습니다. 단, 재고상황, 배송량, 배송위치에 따라 배송일이 조금 더 소요될 수 있는 점 참고 부탁드립니다.</li>
            <li>배송기간이 표시된 일부 상품은 해당 배송일에 배송됩니다.</li>
          </ul>

        </div> -->
      </transition>
  </div>
</template>

<script>
export default {
  props: {
    deliveryDesc: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    vhtmlStyle() {
      const style = {
        fontSize: '11px',
        lineHeight: '1.45',
        textAlign:'left',
        color:'#151721',
      };
      return style;
    },
  },
  methods: {
    toggleAccordion() {
      this.open = !this.open;
    },
  }
}
</script>
